export const documentType = [
  {
    name: 'Passport with Pinfl',
    value: 10,
  },
  {
    name: 'Passport with BirthDate',
    value: 1,
  },
  // {
  //   name: 'IdentityCard',
  //   value: 2,
  // },
  // {
  //   name: 'BirthCertificate',
  //   value: 4,
  // },
  // {
  //   name: 'ForeignPassport',
  //   value: 8,
  // },
];
